import SingleEqual from "../../UI/svg/single-equal";
import DoubleUpArrows from "../../UI/svg/double-up-arrows";
import DownArrows from "../../UI/svg/single-down-arrow";
import DoubleDownArrow from "../../UI/svg/double-down-arrows";
import UpArrow from "../../UI/svg/single-up-arrow";

export default function Notation({ status, count = 1 }) {
  switch (status) {
    case "equal":
      return <SingleEqual count={count} />;
    case "increase":
      return <UpArrow count={count} />;
    case "double_increase":
      return <DoubleUpArrows count={count} />;
    case "decrease":
      return <DownArrows count={count} />;
    case "decrease_double":
      return <DoubleDownArrow count={count} />;
    case "default":
      return null;
  }
}
